module.exports = __webpack_public_path__ + "img/jf-lorenzo-llorente-arquitecto-logo.b0fb769d.png";